import React, { FC } from "react";
import { Flex } from "../../atoms/flex";
import { UNITS } from "../../../constants/units";
import "./graph.css";
import { GraphSkeleton } from "./graph.skeleton";

interface GraphProps {
  value1?: number;
  value2?: number;
  min?: number;
  max?: number;
  className?: string;
  description?: string;
  unit?: UNITS;
  print?: boolean;
  loading?: boolean;
}

/**
 * Graph component
 */
export const Graph: FC<GraphProps> = ({
  description = "No description",
  min = 50,
  max = 100,
  unit = "",
  print,
  className,
  loading,
}) => {
  const maxHeight = 282;
  const minHeight = maxHeight * (min / max);
  const diffHeight = maxHeight - minHeight;

  const top = `M 252 ${114 + diffHeight} 295 ${95 + diffHeight} 390 ${
    95 + diffHeight
  } 363 ${114 + diffHeight} Z`;
  const right = `M 363 ${114 + diffHeight} 390 ${
    95 + diffHeight
  } 390 360 363 394`;

  return (
    <>
      {loading ? (
        <GraphSkeleton />
      ) : (
        <Flex className={`Graph ${className || ""}`}>
          <svg
            width={print ? "256px" : "512px"}
            height={print ? "256px" : "512px"}
            viewBox="0 0 512 512"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g className="Baseplate">
              <path
                style={{ fill: "#BFBFBF" }}
                d="M143.5,347H451l-48,56H40L143.5,347z"
              />
              <path style={{ fill: "#A3A2A2" }} d="M40,403h363v14H40V403z" />
              <path
                style={{ fill: "#898686" }}
                d="M403,403l48-56v14l-48,56V403z"
              />
              <text x="256" y="461" className="ChartHeading">
                {description}
              </text>
            </g>
            <g className="Max">
              <g>
                <rect
                  x="128"
                  y="114"
                  style={{ fill: "#FC8997" }}
                  width="111"
                  height="282"
                />
                <path
                  style={{ fill: "#E07582" }}
                  d="M175,95h93l-29,19H128L175,95z"
                />
                <path
                  style={{ fill: "#D24962" }}
                  d="M239,114l29-19l-2,261l-27,40V114z"
                />
              </g>
              <text x="180" y="30" className="ChartHeading">
                Utan:
              </text>
              <text x="180" y="60" className="ChartHeading">
                {Math.round(max) + unit}
              </text>
            </g>
            <g className="Min">
              <g>
                <rect
                  x="252"
                  y={114 + diffHeight}
                  style={{ fill: "#89C5FC" }}
                  width="111"
                  height={minHeight}
                />
                <path style={{ fill: "#75ADE0" }} d={top} />
                <path style={{ fill: "#4991D2" }} d={right} />
              </g>
              <text x="314" y={30 + diffHeight} className="ChartHeading">
                Med:
              </text>
              <text x="314" y={60 + diffHeight} className="ChartHeading">
                {Math.round(min) + unit}
              </text>
            </g>
          </svg>
        </Flex>
      )}
    </>
  );
};
